import { Picker } from '@ks/sharp-ui';
import formEventBus, { FORM_EVENTS_TYPE } from '../../utils/event-bus';
import objectFormatters from '../component-base/formatters/object';
import { locations } from './locations';

let pickerData = null;

// picker组件抛出的选中值与ksBridge不一致，统一用ksBridge的值
function pickerValueToBridgeValue(pickerValue = []) {
    if (!Array.isArray(pickerValue) || 2 !== pickerValue.length) {
        return null;
    }

    return {
        code: pickerValue[1].value,
        provinceName: pickerValue[0].text,
        cityName: pickerValue[1].text,
    };

}

export async function selectCity() {
    if (!pickerData) {
        pickerData = objectFormatters.cityOptionsToPickerData.fn(locations);
    }
    const _picker = new Promise(resolve => {
        const pickerConfig = {
            data: pickerData,
            cascade: true,
            onPick: (value, valueObj) => resolve(pickerValueToBridgeValue(valueObj)),
        };
        const picker = Picker.create(pickerConfig);
        picker.showPicker();
        formEventBus.$emit(FORM_EVENTS_TYPE.IS_OPEN_PICKER, true);
        picker.$on('hide', () => {
            formEventBus.$emit(FORM_EVENTS_TYPE.IS_OPEN_PICKER, false);
        });
    });
    // 调用方自行try catch吧……
    return await _picker;
}
